module.exports = __webpack_public_path__ + "static/media/no_ads_oct_2021_thumb.873a2d51.jpg";